module.exports = __webpack_public_path__ + "db8e37d27002df293dfc1f34cdb24b17.svg";